import { useEffect } from 'react'

import { useModal } from '../Modal.hook'

import { isMobile } from '@/core/lib'

import AppDownloadModal from '.'

const useAppDownloadModal = ({ inactive = false }: { inactive?: boolean }) => {
  const { open, close } = useModal({
    options: {
      backgroundStyle: {
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
      },
      disableCloseOnClickBackground: true,
    },
  })

  useEffect(() => {
    if (inactive) return
    if (!isMobile()) return

    const STORAGE_KEY = 'app_download_modal_dismissed_until'
    const dismissedUntil = localStorage.getItem(STORAGE_KEY)
    const now = Date.now()

    // 일주일(7일) 기한 체크
    if (dismissedUntil && now < parseInt(dismissedUntil)) return

    open(
      <AppDownloadModal
        closePopup={() => {
          // 일주일 후 타임스탬프 저장 (7일 * 24시간 * 60분 * 60초 * 1000ms)
          const oneWeekLater = now + 7 * 24 * 60 * 60 * 1000
          localStorage.setItem(STORAGE_KEY, oneWeekLater.toString())
          close()
        }}
      />,
    )
    return () => {
      close()
    }
  }, [open, close, inactive])
}

export default useAppDownloadModal
